import React from "react";

interface ILineIconProps {
    size?: number;
    strokeWidth?: number;
}

/** The thin stroke icons from the Present Mode designs. Decorative: hidden from screen readers. */
const LineIcon: React.FC<React.PropsWithChildren<ILineIconProps>> = ({
    size = 24,
    strokeWidth = 2,
    children,
}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        {children}
    </svg>
);

const phoneShape = (
    <>
        <rect x="6" y="2.5" width="12" height="19" rx="2.5" />
        <path d="M11 18h2" />
    </>
);

export const MonitorIcon: React.FC<ILineIconProps> = (props) => (
    <LineIcon {...props}>
        <rect x="2.5" y="4" width="19" height="13" rx="2" />
        <path d="M8 21h8" />
        <path d="M12 17v4" />
    </LineIcon>
);

export const LaptopIcon: React.FC<ILineIconProps> = (props) => (
    <LineIcon {...props}>
        <rect x="3" y="4" width="18" height="12" rx="2" />
        <path d="M2 20h20" />
    </LineIcon>
);

export const PhoneIcon: React.FC<ILineIconProps> = (props) => (
    <LineIcon {...props}>{phoneShape}</LineIcon>
);

export const LockedPhoneIcon: React.FC<ILineIconProps> = (props) => (
    <LineIcon {...props}>
        {phoneShape}
        <rect x="9.5" y="9.5" width="5" height="4" rx="1" />
        <path d="M10.5 9.5V8.3a1.5 1.5 0 0 1 3 0v1.2" />
    </LineIcon>
);

export const ChevronLeftIcon: React.FC<ILineIconProps> = (props) => (
    <LineIcon strokeWidth={2.5} {...props}>
        <path d="M15 5l-7 7 7 7" />
    </LineIcon>
);

export const ChevronRightIcon: React.FC<ILineIconProps> = (props) => (
    <LineIcon strokeWidth={2.5} {...props}>
        <path d="M9 5l7 7-7 7" />
    </LineIcon>
);

export const ChevronDownIcon: React.FC<ILineIconProps> = (props) => (
    <LineIcon strokeWidth={2.5} {...props}>
        <path d="M5 9l7 7 7-7" />
    </LineIcon>
);

export const ChartIcon: React.FC<ILineIconProps> = (props) => (
    <LineIcon strokeWidth={2.5} {...props}>
        <path d="M4 20V10" />
        <path d="M10 20V4" />
        <path d="M16 20v-7" />
        <path d="M22 20H2" />
    </LineIcon>
);

export const EyeIcon: React.FC<ILineIconProps> = (props) => (
    <LineIcon {...props}>
        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
        <circle cx="12" cy="12" r="3" />
    </LineIcon>
);

export const EyeOffIcon: React.FC<ILineIconProps> = (props) => (
    <LineIcon {...props}>
        <path d="M3 3l18 18" />
        <path d="M10.6 5.1A10.9 10.9 0 0 1 12 5c6.5 0 10 7 10 7a17.6 17.6 0 0 1-3.2 4.2" />
        <path d="M6.6 6.6A17.4 17.4 0 0 0 2 12s3.5 7 10 7a10.6 10.6 0 0 0 5.4-1.6" />
    </LineIcon>
);

/** The one filled icon: Start session's play triangle. */
export const PlayIcon: React.FC<Pick<ILineIconProps, "size">> = ({
    size = 22,
}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
        <path d="M7 4.5v15l12.5-7.5z" fill="currentColor" />
    </svg>
);
